import React from 'react';

const AdminContentSkeleton = ({ rows = 4, variant = 'card' }) => {
  if (variant === 'table') {
    return (
      <div className="bg-white rounded-xl border border-gray-200/80 shadow-sm overflow-hidden">
        {[...Array(rows)].map((_, i) => (
          <div key={i} className="flex items-center gap-4 px-5 py-4 border-b border-gray-50 last:border-0 animate-pulse">
            <div className="w-24 h-4 bg-gray-200 rounded-md" />
            <div className="flex-1 space-y-2">
              <div className="w-40 h-3 bg-gray-200 rounded-md" />
              <div className="w-24 h-3 bg-gray-100 rounded-md" />
            </div>
            <div className="w-20 h-4 bg-gray-200 rounded-md" />
            <div className="w-16 h-6 bg-gray-200 rounded-full" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200/80 shadow-sm overflow-hidden">
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="p-5 border-b border-gray-50 last:border-0 animate-pulse">
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1 space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-32 h-5 bg-gray-200 rounded-md" />
                <div className="w-16 h-5 bg-gray-100 rounded-full" />
              </div>
              <div className="w-full h-4 bg-gray-100 rounded-md" />
              <div className="w-3/4 h-4 bg-gray-100 rounded-md" />
              <div className="w-28 h-3 bg-gray-100 rounded-md" />
            </div>
            <div className="flex gap-2 shrink-0">
              <div className="w-20 h-9 bg-gray-200 rounded-lg" />
              <div className="w-9 h-9 bg-gray-200 rounded-lg" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminContentSkeleton;
